import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';
import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { PositionType } from '../../lib/defs/types';
import { mapFromViewPosition } from '../util/mapTools';

const manifest = {
  cup: 'fx.drill/fx.drill.cup.png',
  fire: 'fx.drill/fx.drill.fire.png',
};

export class DrillAnimation extends Container implements IAnimation {
  private _cup!: Sprite;
  private _fire!: Sprite;
  private _position: PositionType;
  public onMove?: (row: number) => void;

  public static assets(): string[] {
    return [manifest.cup, manifest.fire];
  }

  constructor(position: PositionType) {
    super();
    this._position = position;
  }

  public async start(): Promise<void> {
    app.sound.play('puzzle-drill');

    this._fire = Sprite.from(manifest.fire);
    this._fire.anchorX = 0.5;
    this._fire.anchorY = 1;
    this._fire.x = -5;
    this._fire.y = -55;
    this._fire.scaleX = this._fire.scaleY = 0;
    this.addChild(this._fire);

    this._cup = Sprite.from(manifest.cup);
    this._cup.anchorX = 0.55;
    this._cup.anchorY = 0.5;
    this._cup.scaleX = this._cup.scaleY = 0;
    this.addChild(this._cup);

    this.x = this._position.x + 40;
    this.y = 0;

    await gsap.to(this._cup, {
      scaleX: 1,
      scaleY: 1,
      duration: 0.4,
      ease: 'back.out',
    });

    await gsap.to(this._cup, {
      rotation: Math.PI,
      duration: 0.3,
      ease: 'sine.in',
    });

    const destination = 1200;
    await gsap.to(this, {
      y: destination,
      duration: 1.3,
      ease: 'linear',
      onUpdate: () => this._onUpdate(),
    });
  }

  public stop() {
    this.removeChild(this._cup);
  }

  private _onUpdate() {
    const mapPos = mapFromViewPosition({
      x: this.x,
      y: this.y - 460,
    });
    this.onMove?.(mapPos.y);

    this._fire.scaleY = Math.sin(this.y * 0.2) * 0.2 + 0.9;
    this._fire.scaleX = Math.cos(this.y * 0.3) * 0.2 + 0.9;
  }
}
